// DataContext.js
import React, { createContext, useState } from 'react';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [Postdata, setPostData] = useState({});
  console.log("post data ",Postdata);

  const [verified, setVerified] = useState({
    email: false,
    phone: false
  });
  const [file, setPostfile] = useState();
  const [activeStep, setActiveStep] = useState(sessionStorage.getItem("step") ? sessionStorage.getItem("step") : 0);
  const [Kyc, setKyc] = useState({
    Pan: false,
    Aadhar: false,
    image: false
  });

  return (
    <DataContext.Provider value={{ Postdata, setPostData, verified, setVerified, file, setPostfile, activeStep, setActiveStep, Kyc, setKyc }}>
      {children}
    </DataContext.Provider>
  );
};

export default DataContext;
